import { phoneNumberFormatting, getName } from "js/formatting";
import CardWithFields from "components/General/CardWithFields";
import { useTranslation } from "react-i18next";

export default function OwnerCard({ owner }) {
  const { addressLine1, addressLine2, city, postalCode, state } = owner.address;
  const { phoneNumber } = owner.phone;
  const { address: emailAddress } = owner.email;
  const { t } = useTranslation();

  return (
    <CardWithFields
      ariaLabel={t("AgentOwnerCard-expand-collapse-label")}
      cardTitle={t("AgentOwnerCard-title")}
      cardFields={[
        {
          title: t("AgentOwnerCard-label-1"),
          value: getName(owner.person),
        },
        {
          title: t("AgentOwnerCard-label-2"),
          value: (
            <>
              {addressLine1}
              <p>{addressLine2}</p>
              {`${city}, ${state} ${postalCode.substring(0, 5)}`}
            </>
          ),
        },
        {
          title: t("AgentOwnerCard-label-3"),
          value: (
            <a href={`tel:+1${phoneNumber}`}>
              {phoneNumberFormatting(phoneNumber)}
            </a>
          ),
        },
        {
          title: t("AgentOwnerCard-label-4"),
          value: (
            <a href={`mailto:${emailAddress}`} className="break-all">
              {emailAddress}
            </a>
          ),
        },
      ]}
    />
  );
}
